import { Image } from '@chakra-ui/react'
import loadingImage from '~/assets/loading.gif'

const LoadingSpinner = () => {
  return <Image src={loadingImage} m={16} width="2.5rem" alt="Loading" />
}

export default LoadingSpinner
